import { sizes, TABLET } from '@src/styled/media'
import { wordsToTestId } from '@src/utils'
import * as React from 'react'
import styled, { css } from 'styled-components'

export interface Item {
  name: string
  href: string
  external?: string
  key?: number
  icon: string
  id: number
  hideOnMedium?: boolean
}

export interface MenuItemProps {
  item: Item
  key: number
  onClick?: () => void
}

const MenuLink = styled.a<{ hideOnMedium?: boolean }>`
  ${({ hideOnMedium }) =>
    hideOnMedium &&
    css`
      @media (min-width: ${sizes[TABLET]}px) {
        display: none !important;
      }
    `}
`

export const MenuItem: React.FunctionComponent<MenuItemProps> = ({ item, onClick }) => (
  <li key={item.key}>
    <MenuLink
      data-test={`menu-link-${wordsToTestId(item.name)}`}
      className={`icon ${item.icon}`}
      href={item.href}
      target={item.external && '_blank'}
      rel={item.external && 'noopener noreferrer'}
      hideOnMedium={item.hideOnMedium}
      onClick={onClick}
    >
      {item.name}
    </MenuLink>
  </li>
)



// WEBPACK FOOTER //
// ./src/components/Header/MenuItem.tsx